export const OVERRIDE_COOKIE = 'toggle-overrides';
export const CONSUMER_TAG = 'new-stack-web';

export enum FEATURES {
  TEST_TOGGLE = 'TEST_TOGGLE',

  /**
   * [FLEX-82](https://belongranda.atlassian.net/browse/FLEX-82): Live Chat attachments
   */
  LIVE_CHAT_ATTACHMENTS = 'live-chat-attachments',

  /**
   * [AMF-2889](https://belongranda.atlassian.net/browse/AMF-2889): ID verification\
   * NOTE: This is required to be long lived so we can turn it off if third party service has issues
   */
  ID_VERIFICATION = 'id-verification-ui',

  /**
   * [EF-2](https://belongranda.atlassian.net/browse/EF-2): eSIM
   */
  ESIM_SWAP = 'esim-swap',

  /**
   * [EF-2](https://belongranda.atlassian.net/browse/EF-2): Show the eSIM 'install via app' option
   */
  ESIM_APP_INSTALL = 'esim-app-install',

  /**
   * [EF-26](https://belongranda.atlassian.net/browse/EF-26): 'Sim Type' selection screen
   */
  ESIM_ACTIVATE = 'esim-activate',

  /**
   * [EF-39](https://belongranda.atlassian.net/browse/EF-39): Installation key for port-in orders when installing eSIM
   */
  ESIM_PORT_IN_SECURE_INSTALL = 'esim-port-in-secure-install',

  /**
   * [ES1-814](https://belongranda.atlassian.net/browse/ES1-814): Enable OTP for sim swap flow
   */
  OTP_SIM_SWAP = 'otp-sim-swap',

  /**
   * [DEF-17](https://belongranda.atlassian.net/browse/DEF-17): Mobile Plans Accordion AB Test
   */
  MOBILE_PLANS_ACCORDION_AB_TEST = 'mobile-plans-accordion-ab-test',

  /**
   * [PLM1-1218](https://belongranda.atlassian.net/browse/PLM1-1218),
   * [PLM1-1219](https://belongranda.atlassian.net/browse/PLM1-1219):
   * Mobile PlanCard Offers Uplift. Enabling the plan cards to reflect offer details.
   */
  PLANCARD_OFFERS = 'mobile-plancard-offer-uplift',

  /**
   * [DEE-1007](https://belongranda.atlassian.net/browse/DEE-1007): Enables nbn join journey client side resumption for cart page
   */
  NBN_CLIENT_SIDE_RESUMPTION_CART = 'client-side-resumption-cart',

  /**
   * [DEE-1366](https://belongranda.atlassian.net/browse/DEE-1366): Enables nbn join journey server side resumption for Email capture screen in register page
   */
  NBN_SERVER_SIDE_RESUMPTION_EMAIL = 'server-side-resumption-email',

  /**
   * Enables fetching MOBILE product catalogue data directly from product API instead of Contentful product sync.
   */
  MOBILE_PRODUCT_API = 'mobile-product-api',

  /**
   * [PLM1-1507](https://belongranda.atlassian.net/browse/PLM1-1507): Accessible form loading implementation.
   * Note: This will only impact the visual button loading and not the input readOnly if opted in.
   */
  ACCESSIBLE_FORM_LOADING = 'accessible-form-loading',

  /**
   * [DEE-1188](https://belongranda.atlassian.net/browse/DEE-1188): Filter plan cards on join journey implementation.
   */
  FILTER_PLANCARDS_ON_JOIN_JOURNEY = 'filter-plancards-on-join-journey',

  /**
   * [FBL-1025](https://belongranda.atlassian.net/browse/FBL-1025): Enables Shop/Deals visibility rules in the global header menu
   */
  AUTHENTICATED_SHOP = 'authenticated-shop',

  /**
   * [FBL-1076](https://belongranda.atlassian.net/browse/FBL-1076): Enables 3DSecure for Braintree card payments in flows that opt in via `withBraintree`
   */
  BRAINTREE_THREE_D_SECURE = 'braintree-three-d-secure',

  /**
   * [DEF-203](https://belongranda.atlassian.net/browse/DEF-203): Displays important terms in the payment page.
   */
  IMPORTANT_TERMS_IN_PAYMENT_PAGE = 'important-terms-in-payment-page',

  /**
   * [TVT-2](https://belongranda.atlassian.net/browse/TVT-2): Enables the nbn Reconnect CTA (address prefill and analytics) on cancelled service tiles
   */
  NBN_RECONNECT = 'nbn-reconnect',

  /**
   * [FLEX-1272](https://belongranda.atlassian.net/browse/FLEX-1272): Enable the contact number update confirmation modal.
   */
  CONTACT_NUMBER_UPDATE_CONFIRMATION_MODAL = 'contact-number-update-confirmation-modal'
}
